module.exports = __webpack_public_path__ + "static/media/TelaSaqueReaporteEN.f90c578c.png";